import { defineComponent as _defineComponent } from 'vue'
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref, watchEffect } from "../../../../adapter-vue";
import documentLink from "../../../../utils/documentLink";
import Icon from "../../../common/Icon.vue"
import selectedIcon from "../../../../assets/icon/selected.svg";
import { groupIntroConfig } from "./config";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  groupType: {
    type: String,
    default: '',
  },
},
  emits: ['selectType'],
  setup(__props, { emit }) {

const props = __props



const type = groupIntroConfig;

const selectType = ref();



watchEffect(() => {
  selectType.value = props.groupType;
})

const selected = (item: any) => {
  selectType.value = item.type;
  emit('selectType', item.type);
};


return { __sfc: true,props, type, selectType, emit, selected, TUITranslateService, documentLink, Icon, selectedIcon }
}

})